import React from 'react';
import clsx from 'clsx';
import { connect } from 'react-redux';

// Components
import CmBanner from 'src/universal/components/CmBanner';
import {
  Box,
  Element,
  Typography,
  Button,
  FontType,
  Color,
  Type,
  BackgroundImage
} from '@americanexpress/aqx-components';

// selectors
import { getVacPageData } from 'page_modules/business-vac/redux/mainPageData';
import {
  showG162Banner,
  getG162Data
} from 'src/universal/components/Experiments/G162/redux';

// utils
import {
  sendDTMClickEvent,
  mapUrlWithDtmLinkQuery
} from 'service_modules/models/dtm-tagging';

// styles
import styles from './__styles__/index.scss?modules';
import g162Styles from 'src/universal/components/Experiments/G162/__styles__/index.scss?modules';

const PageBreakBanner = ({
  pageBreakData,
  renderCmBanner,
  isCm,
  mobile,
  display = true,
  showG162,
  g162Data,
  activeFilter
}) => {
  if (renderCmBanner) {
    return <CmBanner display={display} />;
  } else if (isCm && !showG162) {
    return null;
  }

  if (!pageBreakData) {
    return null;
  }

  const { filterData, g162Logo } = g162Data;
  const { header, imageUrl, mobileImageUrl, logo, button } =
    showG162 && filterData ? filterData : pageBreakData || {};

  const g162Gradient = {
    angle: '90deg',
    colors: ['#00175A 25%', 'rgba(0, 23, 90, 0.00)']
  };

  const bauGradient = {
    angle: '270deg',
    colors: ['transparent', '#00175A 100%']
  };

  const g162AllCards = showG162 && activeFilter === 'all-cards';
  const g162Airlines = showG162 && activeFilter === 'airlines';

  const buttonClick = () => {
    sendDTMClickEvent(button.dtm);
    return (window.location.href = mapUrlWithDtmLinkQuery(button.url, button.dtm));
  };
  if (!mobile) {
    return (
      <BackgroundImage
        imageUrl={imageUrl}
        className={clsx(
          styles.breakBox,
          { [styles.display]: display },
          { [g162Styles.bannerBox]: showG162 },
          {
            [g162Styles.allCards]: g162AllCards
          },
          {
            [g162Styles.airlines]: g162Airlines
          }
        )}
        height={showG162 ? 322 : 340}
        $gradientProps={showG162 ? g162Gradient : bauGradient}
        $reverseGradientOrder={true}
      >
        <Element
          className={clsx(styles.breakHeader, {
            [g162Styles.bannerHeader]: showG162
          })}
        >
          <Typography
            Component="h2"
            $family={FontType.BentonLight}
            $size={30}
            theme={{ color: Color.White }}
          >
            {header}
          </Typography>
        </Element>
        <Element
          className={clsx(styles.buttonContainer, {
            [g162Styles.bannerButton]: showG162
          })}
          theme={{
            marginTop: showG162 ? 30 : 40,
            marginBottom: showG162 ? 30 : 15
          }}
        >
          <Button
            $type={Type.Secondary}
            theme={{
              focusLight: true
            }}
            onClick={buttonClick}
            aria-label={button?.alt}
          >
            {button?.title}
          </Button>
        </Element>
        <Element
          className={clsx(styles.breakLogo, {
            [g162Styles.bannerLogo]: showG162
          })}
        >
          <img
            src={showG162 ? g162Logo?.imageUrl : logo?.imageUrl}
            alt={showG162 ? g162Logo?.alt : logo?.alt}
            loading="lazy"
          />
        </Element>
      </BackgroundImage>
    );
  } else {
    return (
      <Box
        $glow="lighter"
        className={clsx(
          styles.mobileBox,
          { [styles.display]: display },
          { [g162Styles.bannerMobile]: showG162 }
        )}
      >
        <Element className={styles.mobileImage}>
          <img src={mobileImageUrl} alt={''} loading="lazy" />
        </Element>
        <Element className={styles.mobileHeader}>
          <Typography
            Component="h2"
            $family={showG162 ? FontType.BentonRegular : FontType.BentonLight}
            $size={20}
            theme={{
              color: Color.White
            }}
          >
            {header}
          </Typography>
        </Element>
        <Element
          className={styles.mobileButton}
          theme={{
            marginTop: 20,
            marginBottom: 20
          }}
        >
          <Button
            $type={showG162 ? Type.Secondary : Type.Primary}
            theme={{
              focusLight: true
            }}
            onClick={buttonClick}
            aria-label={button?.alt}
          >
            {button?.title}
          </Button>
        </Element>
        <Element className={styles.mobileLogo}>
          <img
            src={showG162 ? g162Logo?.imageUrl : logo?.imageUrl}
            alt={showG162 ? g162Logo?.alt : logo?.alt}
            loading="lazy"
          />
        </Element>
      </Box>
    );
  }
};

const mapStateToProps = state => {
  const activeFilter = state?.filter?.activeFilter;
  return {
    pageBreakData: getVacPageData(state).pageBreakBanner,
    showG162: showG162Banner(state, activeFilter),
    g162Data: getG162Data(state, activeFilter),
    activeFilter: activeFilter
  };
};

export default connect(mapStateToProps)(PageBreakBanner);
